import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import Image from 'Components/frameworks/image/Image';
import { themes } from './AdditionItemImage.themes';
type AdditionItemImageProps = {
  image?: {
    alt?: string;
    src: string;
  };
  label?: string;
  ratioKey?: MediaRatios;
  ratioDisplay?: number;
  symbol?: ReactNode;
  theme?: keyof typeof themes;
};
export const AdditionItemImage = ({
  image = {},
  label,
  symbol,
  ratioDisplay = 0.5,
  ratioKey = ratioUtils.XL,
  theme = 'default',
}: AdditionItemImageProps) => {
  if (!image.src) {
    return null;
  }

  const { thItem, thItemImage, thItemLabel, thItemLabelIcon, thItemLabelIconSize } = themes[theme];
  return (
    <Fragment>
      <div className={thItem}>
        <Image
          altMsg={image.alt}
          className={thItemImage}
          imageUrl={image.src}
          ratioDisplay={ratioDisplay}
          ratioKey={ratioKey}
        />
        {symbol}
      </div>
      {!!label && (
        <p className={thItemLabel} data-testid="AdditionItemImage-label">
          <Icon className={thItemLabelIcon} name={ICONS.CHECK} width={thItemLabelIconSize} />
          {label}
        </p>
      )}
    </Fragment>
  );
};
